export default {
  title: 'App mobile',
  fields: {
    name: 'Nome app',
  },
  buttons: {
    save: 'Salva',
  },
};
